const PbxxStore = require('./src/pbxx_store')
const store = new PbxxStore()

require('./src/registration_key/mapper')(store)
require('./src/user/mapper')(store)
require('./src/note/mapper')(store)
require('./src/asset/mapper')(store)
require('./src/digital_asset/mapper')(store)
require('./src/eligibility_criteria/mapper')(store)

require('./src/retailer_account/mapper')(store)
require('./src/retailer/mapper')(store)
require('./src/brand/mapper')(store)
require('./src/division/mapper')(store)

require('./src/facebook_account/mapper')(store)
require('./src/twitter_account/mapper')(store)
require('./src/facebook_page/mapper')(store)

require('./src/group/mapper')(store)
require('./src/smart_group/mapper')(store)
require('./src/campaign/mapper')(store)
require('./src/campaign_spending_summaries/mapper')(store)
require('./src/invitation/mapper')(store)
require('./src/communication/mapper')(store)
require('./src/communication_automation/mapper')(store)

require('./src/local_ad_balance/mapper')(store)
require('./src/ad_run/mapper')(store)
require('./src/ad_run_task/mapper')(store)
require('./src/allocation_detail/mapper')(store)

require('./src/reporting/brand_time_series/mapper')(store)
require('./src/reporting/campaign_impressions/mapper')(store)
require('./src/reporting/pulse_location/mapper')(store)
require('./src/reporting/pulse_aggregates/mapper')(store)
require('./src/reporting/pulse_social_statistics/mapper')(store)
require('./src/reporting/pulse_engagement/mapper')(store)

require('./src/reporting/campaign_reporting_state_locations/mapper')(store)
require('./src/reporting/campaign_reporting_ad_run_tasks/mapper')(store)
require('./src/reporting/campaign_reporting_retailer_share_summary/mapper')(store)

require('./src/facebook_share/mapper')(store)
require('./src/twitter_share/mapper')(store)
require('./src/instagram_share/mapper')(store)
require('./src/email_share/mapper')(store)
require('./src/embed_share/mapper')(store)
require('./src/share_setting/mapper')(store)
require('./src/share_setting_copy_option/mapper')(store)
require('./src/content_discovery_item/mapper')(store)

require('./src/brand_request/mapper')(store)
require('./src/reporting/brand_requests/mapper')(store)

require('./src/template/mapper')(store)
require('./src/landing_page/mapper')(store)
require('./src/landing_page_widget/mapper')(store)
require('./src/widget/mapper')(store)

module.exports = store
